import React, {lazy, Suspense} from 'react';
import {BrowserRouter} from 'react-router-dom'
import {renderRoutes} from 'react-router-config'
import {Redirect} from "react-router";

import {Spin} from 'antd';
import {useSelector} from "react-redux";

const App = lazy(() => import('@/App'))
const NotFoundView = lazy(() => import('@/views/NotFoundView'))
const UploadView = lazy(() => import('@/views/UploadView'))

const routes = [
  {
    path: "/",
    component: App,
    routes: [
      {
        path: "/upload",
        key: "404",
        component: UploadView,
      },
      {
        path: "*",
        key: "404",
        exact: false,
        component: NotFoundView,
      },
    ]
  },
]
export const BasicRoute = () => {
  const state = useSelector((state: any) => state.store)
  console.log(state)
  return (
    <Suspense fallback={<Spin/>}>
      <BrowserRouter>
        <Spin spinning={state.spin}>
          {renderRoutes(routes)}
        </Spin>
      
      </BrowserRouter>
    </Suspense>
  )
};